import * as React from 'react';
import Modal, {
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter
} from '../../common/modal';
import classnames from 'classnames';
import { connect } from 'react-redux';
import UploadMedia from './UploadMedia';
import UploadedMediaItem from './UploadedMediaItem';
import { saveMedia } from '../../../services/media.service';
import { IApplicationState } from '../../../reducers';
import { messageStatus } from '../../../constants/messageStatus';
import MediaLibraryList, { MediaSelectType } from './MediaLibraryList';
import { MAX_UPLOAD_STR } from '@nexxt/common/constants';
import { Notes } from '../../common/notes';
import { UilInfoCircle } from '@iconscout/react-unicons';
import { ALERT_MESSAGE_TYPES } from '../../../interface/project.interface';

export interface IMediaLibraryAddProps {
    isOpen: boolean;
    type: MediaSelectType;
    notify: any;
    medias?: any[];
    tags?: any[];
    showMediaLibrary: boolean;
    isMultiple?: boolean;
    videoOnly?: boolean;
    withFilename?: boolean;
    setSelectedMedia: (newMedia: any, hasMultiMedia?: boolean) => void;
    saveMedia: (data) => void;
    onClose: (type?: any) => void;
    onCancel: (type?: any) => void;
}

export interface IMediaLibraryAddState {
    uploadedFileIds: string[];
    uploadedFiles: Record<string, any>;
    isSaving: boolean;
    currentTab: 'upload' | 'medialibrary';
    selectedMedia: any | null;
    selectedMediaType: 'upload' | 'medialibrary';
}

class MediaLibraryAdd extends React.Component<
    IMediaLibraryAddProps,
    IMediaLibraryAddState
> {
    static defaultProps = {
        showMediaLibrary: true
    };
    constructor(props) {
        super(props);
        this.state = {
            uploadedFileIds: [],
            uploadedFiles: {},
            isSaving: false,
            currentTab: 'upload',
            selectedMedia: null,
            selectedMediaType: 'upload'
        };
    }

    changeTab = (currentTab: 'upload' | 'medialibrary') => {
        this.setState({
            currentTab
        });
    };

    onMediaSelect = (
        selectedMedia: any,
        selectedMediaType: 'upload' | 'medialibrary'
    ) => {
        this.setState({
            selectedMedia,
            selectedMediaType
        });
    };

    isAllUploaded = () => {
        let uploadedAll = true;
        this.state.uploadedFileIds.forEach((id) => {
            const imgObj = this.state.uploadedFiles[id];
            if (imgObj.isUploading) {
                uploadedAll = false;
            }
        });
        return uploadedAll;
    };

    isValid = (setValue = true) => {
        let isError = false;
        let updatedFiles = {};
        this.state.uploadedFileIds.forEach((id) => {
            const imgObj = this.state.uploadedFiles[id];
            const errorObj = {
                title: '',
                selectedTags: '',
                isError: false
            };
            if (imgObj.title.trim() === '') {
                isError = true;
                errorObj.isError = true;
                errorObj.title = 'title is required';
            }

            // if(imgObj.selectedTags.length === 0) {
            //     isError = true;
            //     errorObj.isError = true;
            //     errorObj.selectedTags = "selectedTags is required";
            // }
            updatedFiles = {
                ...updatedFiles,
                [`${id}`]: { ...imgObj, error: { ...errorObj } }
            };
        });
        if (setValue) {
            this.setState({
                uploadedFiles: { ...updatedFiles }
            });
        }
        return !isError;
    };

    createUploadObject = (id) => {
        return {
            id,
            title: '',
            selectedTags: [],
            isUploading: true,
            mediaURL: '',
            value: '',
            error: {
                title: '',
                selectedTags: '',
                isError: false
            }
        };
    };

    onUpload = (id, status, url, filename) => {
        if (status === 'uploading') {
            const imageObj = this.createUploadObject(id);
            this.setState({
                uploadedFileIds: [...this.state.uploadedFileIds, id],
                uploadedFiles: {
                    ...this.state.uploadedFiles,
                    [`${id}`]: imageObj
                }
            });
        } else {
            this.setState(
                {
                    uploadedFiles: {
                        ...this.state.uploadedFiles,
                        [`${id}`]: {
                            ...this.state.uploadedFiles[`${id}`],
                            title: filename,
                            isUploading: false,
                            mediaURL: url,
                            value: url
                        }
                    }
                },
                () => {
                    if (this.props.showMediaLibrary) {
                        this.onMediaSelect(
                            this.state.uploadedFiles[id],
                            'upload'
                        );
                    }
                }
            );
        }
    };

    handleSave = () => {
        if (this.props.showMediaLibrary) {
            if (this.state.selectedMedia) {
                if (this.state.selectedMediaType === 'medialibrary') {
                    this.props.setSelectedMedia({
                        ...this.state.selectedMedia,
                        isUploadedImage: false
                    });
                } else {
                    if (this.props.isMultiple) {
                        const uploadedImages = Object.values(
                            this.state.uploadedFiles
                        );
                        if (uploadedImages.length) {
                            if (this.props.withFilename) {
                                const images = uploadedImages.map((image) => ({
                                    mediaURL: image.mediaURL,
                                    title: image.title
                                }));
                                this.props.setSelectedMedia(images, true);
                            } else {
                                const imageURLs = uploadedImages.map(
                                    (image) => image.mediaURL
                                );
                                this.props.setSelectedMedia(imageURLs, true);
                            }
                        }
                    } else {
                        if (this.props.withFilename) {
                            this.props.setSelectedMedia({
                                title: this.state.selectedMedia.title,
                                mediaURL: this.state.selectedMedia.mediaURL
                            });
                        } else {
                            this.props.setSelectedMedia({
                                src: this.state.selectedMedia.mediaURL,
                                userUploaded: true,
                                tags: [],
                                isUploadedImage: true
                            });
                        }
                    }
                }
            } else {
                this.props.notify('Select or upload media');
            }
            return;
        }
        if (this.isValid()) {
            const gifRegex = /\.gif$/i;
            const imageRegex = /\.(jpeg|png|jpg|jfif)$/i;
            const allPromises = [];
            this.state.uploadedFileIds.forEach((id) => {
                const mObj = { ...this.state.uploadedFiles[id] };
                const mediaObj: any = {
                    itemTags: mObj.selectedTags,
                    mediaURL: mObj.mediaURL,
                    label: mObj.title
                };

                if (gifRegex.test(mediaObj.mediaURL)) {
                    mediaObj.type = 'gif';
                } else if (imageRegex.test(mediaObj.mediaURL)) {
                    mediaObj.type = 'image';
                } else {
                    mediaObj.type = 'video';
                }
                mediaObj.userUploaded = true;
                allPromises.push(this.props.saveMedia(mediaObj));
            });
            this.setState({
                isSaving: true
            });
            Promise.all(allPromises).then(
                () => {
                    this.setState({
                        isSaving: false
                    });
                    this.props.setSelectedMedia(null);
                    this.props.notify(
                        'Media(s) saved successfully',
                        messageStatus.SUCCESS
                    );
                },
                () => {
                    this.setState({
                        isSaving: false
                    });
                }
            );
        }
    };

    onTagSelect = (id, value) => {
        if (this.state.isSaving) {
            return;
        }
        this.setState({
            uploadedFiles: {
                ...this.state.uploadedFiles,
                [`${id}`]: {
                    ...this.state.uploadedFiles[id],
                    selectedTags: value || []
                }
            }
        });
    };

    onTitleChange = (id, value) => {
        if (this.state.isSaving) {
            return;
        }
        this.setState({
            uploadedFiles: {
                ...this.state.uploadedFiles,
                [`${id}`]: { ...this.state.uploadedFiles[id], title: value }
            }
        });
    };

    onDelete = (id) => {
        const index = this.state.uploadedFileIds.indexOf(id);
        const uploadedFileIds = [...this.state.uploadedFileIds];
        uploadedFileIds.splice(index, 1);
        this.setState({
            uploadedFileIds: [...uploadedFileIds]
        });
    };

    uploadMedia = () => {
        const { props, state } = this;
        let uploadingFiles = [];
        if (state.uploadedFileIds.length) {
            uploadingFiles = state.uploadedFileIds.map((id, index) => {
                const imageObj = this.state.uploadedFiles[id];
                return (
                    <UploadedMediaItem
                        key={'media-uploading-' + id}
                        index={index}
                        {...imageObj}
                        onClose={() => this.onDelete(id)}
                        onTagSelect={(value) => {
                            this.onTagSelect(id, value);
                        }}
                        onTitleChange={(value) => {
                            this.onTitleChange(id, value);
                        }}
                        onClick={(media) => {
                            this.onMediaSelect(media, 'upload');
                        }}
                        showMediaLibrary={this.props.showMediaLibrary}
                        selectedMedias={this.state.selectedMedia}
                        setSelectedMedia={() => {
                            this.onMediaSelect(imageObj, 'upload');
                        }}
                        tags={props.tags}
                    />
                );
            });
        }
        const uploadMedia = (
            <UploadMedia
                isSingle={state.uploadedFileIds.length === 0}
                isMultiple={props.isMultiple || false} // props.isMultiple
                onUpload={this.onUpload}
                notify={this.props.notify}
                type={this.props.type}
            />
        );

        const videoOnlyBubbles = [
            { subtext: 'Must be', text: '.mp4' },
            { subtext: 'Less than', text: '1min' },
            { subtext: 'Up to', text: '200MB' }
        ];

        return (
            <React.Fragment>
                {' '}
                <div className="media-upload-block">
                    {/* Image Upload */}
                    <div className="media-upload--top">
                        {props.videoOnly ? (
                            <Notes type={ALERT_MESSAGE_TYPES.DANGER}>
                                <div className="note-feature-container">
                                    <div className="note-feature-header">
                                        <UilInfoCircle size={36} />
                                        <span className="note-feature-header-content">
                                            Video
                                            <br />
                                            Requirements
                                        </span>
                                    </div>
                                    <div className="note-feature-body">
                                        {videoOnlyBubbles.map((bubble, i) => (
                                            <div
                                                className="note-feature-body-item"
                                                key={i}
                                            >
                                                <div className="note-feature-body-item-content">
                                                    <span className="note-feature-body-item-content-subtext">
                                                        {bubble.subtext}
                                                    </span>
                                                    <span>{bubble.text}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Notes>
                        ) : (
                            <ul className="media-upload--list">
                                <li className="media-upload--list-item">
                                    <span className="media-upload--icon-hold">
                                        <i className="nx nx-image-mb"></i>
                                    </span>
                                    <span className="media-upload--description">
                                        <span className="media-upload--title">
                                            Images
                                            <em> PNG, JPG</em>
                                        </span>
                                    </span>
                                </li>

                                <li className="media-upload--list-item">
                                    <span className="media-upload--icon-hold">
                                        <i className="nx nx-gif-mb"></i>
                                    </span>
                                    <span className="media-upload--description">
                                        <span className="media-upload--title">
                                            Gif
                                            <em> File size: 500X500 or 1:1</em>
                                        </span>
                                    </span>
                                </li>

                                <li className="media-upload--list-item">
                                    <span className="media-upload--icon-hold">
                                        <i className="nx nx-video-mb"></i>
                                    </span>
                                    <span className="media-upload--description">
                                        <span className="media-upload--title">
                                            Videos
                                            <em>
                                                {' '}
                                                MP4, up to {MAX_UPLOAD_STR}
                                            </em>
                                        </span>
                                    </span>
                                </li>
                            </ul>
                        )}
                    </div>

                    <div className="upload">
                        {uploadingFiles}
                        {uploadMedia}
                    </div>
                </div>{' '}
                {/* Media upload */}
            </React.Fragment>
        );
    };

    mediaLibrary = () => {
        return (
            <MediaLibraryList
                type={this.props.type}
                selectedMedias={this.state.selectedMedia}
                setSelectedMedia={(media) => {
                    this.onMediaSelect(media, 'medialibrary');
                }}
                selectedMediaType={this.state.selectedMediaType}
                showAddMedia={false}
            />
        );
    };

    render() {
        const { props, state } = this;
        let isDoneEnabled = false;
        if (this.props.showMediaLibrary) {
            isDoneEnabled = this.state.selectedMedia;
        } else {
            isDoneEnabled =
                !this.state.isSaving &&
                this.state.uploadedFileIds.length > 0 &&
                this.isAllUploaded();
        }

        return (
            <Modal
                isOpen={props.isOpen}
                className={classnames('modal-dialog--media-library', {
                    'media-library': state.currentTab === 'medialibrary',
                    'with-medialibrary': props.showMediaLibrary
                })}
            >
                <ModalHeader onClose={props.onClose}>
                    {/* <ModalTitle>Select or upload media</ModalTitle> */}
                    <ModalTitle>Media Manager</ModalTitle>
                    {this.props.showMediaLibrary ? (
                        <div className="modal-tabs">
                            <div
                                className={classnames('tab-item', {
                                    active: state.currentTab === 'upload'
                                })}
                                onClick={() => this.changeTab('upload')}
                            >
                                Upload
                            </div>
                            <div
                                className={classnames('tab-item', {
                                    active: state.currentTab === 'medialibrary'
                                })}
                                onClick={() => this.changeTab('medialibrary')}
                            >
                                My Files
                            </div>
                        </div>
                    ) : null}
                </ModalHeader>
                <ModalBody className="">
                    {state.currentTab === 'upload'
                        ? this.uploadMedia()
                        : this.mediaLibrary()}
                </ModalBody>
                <ModalFooter>
                    <button
                        className="btn btn--sm btn--transparent m-r-10"
                        onClick={props.onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        className={`btn btn--sm btn--green ${
                            isDoneEnabled ? '' : 'disabled'
                        }`}
                        onClick={this.handleSave}
                        disabled={!isDoneEnabled}
                    >
                        {this.state.isSaving ? 'Saving...' : 'Done'}
                    </button>
                </ModalFooter>
            </Modal>
        );
    }
}

const mapStateToProps = ({ mediaReducer }: IApplicationState) => ({
    tags: mediaReducer.tags,
    medias: mediaReducer.medias
});

const mapDispatchToProps = (dispatch) => ({
    saveMedia: (data: any) => dispatch(saveMedia(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(MediaLibraryAdd);
